/* ── Complete the look ─────────────────────────────────────────────
   Behaviour for the card snippets/feral-look.liquid renders in the cart
   drawer. Everything is delegated on document: Dawn's renderContents, the
   quantity stepper and the add-ons rail all replace #CartDrawer's markup
   wholesale, so nothing here may hold on to a node.

   A size tap POSTs /cart/add.js with the drawer sections (one round trip)
   and swaps them in, exactly as the "last call." rail does. The fresh
   Liquid no longer renders the card (the piece is in the bag), and the new
   line lands at the top of the list and flashes once. feral-owned-tracking
   sees the /cart/add.js fetch and sends AddToCart as for any other add.
   ⚠️ No custom events: the collector 400s names it does not know (MEASURED
   2026-09-30: CompleteLookViewed / CompleteLookAdded, both rejected). A card
   add is an AddToCart for the paired product on the source product's page.

   Session state, per source product id:
     feral_look_hidden  the shopper closed it; stays closed this session
     feral_look_seen    its entrance has played; later renders are static */
(function () {
  'use strict';

  var HIDDEN = 'feral_look_hidden';
  var SEEN = 'feral_look_seen';

  function read(key) {
    try {
      var v = JSON.parse(sessionStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function remember(key, id) {
    var list = read(key);
    if (list.indexOf(id) !== -1) return;
    list.push(id);
    try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  /* Runs synchronously after every drawer mutation (a MutationObserver
     callback is a microtask, so this lands before the browser paints): a
     closed card never flashes back, and a card element that arrives in a
     re-render after its entrance has already played is static.
     ⚠️ Only NEW elements are judged. The drawer mutates its own subtree
     right after opening (the custom scrollbar is inserted in a rAF), and
     settling the element that is mid-entrance cut the animation to a blink. */
  function settle() {
    var cards = document.querySelectorAll('[data-feral-look]');
    if (!cards.length) return;
    var hidden = read(HIDDEN);
    var seen = read(SEEN);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var id = card.getAttribute('data-source-id');
      if (hidden.indexOf(id) !== -1) card.hidden = true;
      if (card.__feralLook) continue;
      card.__feralLook = true;
      if (seen.indexOf(id) !== -1) card.classList.add('is-settled');
    }
  }

  // Played once: the same element must not replay when the drawer closes and
  // reopens, and a re-rendered one arrives settled (above).
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'feral-look-in' && e.target.hasAttribute('data-feral-look')) {
      e.target.classList.add('is-settled');
      remember(SEEN, e.target.getAttribute('data-source-id'));
    }
  });

  var d = drawer();
  if (d && typeof MutationObserver !== 'undefined') {
    new MutationObserver(settle).observe(d, { childList: true, subtree: true });
  }
  settle();

  function swap(sections) {
    if (sections && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var target = document.querySelector('#CartDrawer');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    }
    if (sections && sections['cart-icon-bubble']) {
      var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var ss = doc2.querySelector('.shopify-section');
      var host = document.getElementById('cart-icon-bubble');
      if (ss && host) host.innerHTML = ss.innerHTML;
    }
  }

  function say(text) {
    var live = document.getElementById('CartDrawer-LiveRegionText');
    if (live) live.textContent = text;
  }

  var busy = false;

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-feral-look-dismiss]');
    if (close) {
      var gone = close.closest('[data-feral-look]');
      if (!gone) return;
      var line = gone.closest('.feral-cart__item');
      var hadFocus = gone.contains(document.activeElement);
      remember(HIDDEN, gone.getAttribute('data-source-id'));
      var finish = function () {
        gone.hidden = true;
        if (hadFocus && line) {
          var name = line.querySelector('.feral-cart__name');
          if (name) name.focus();
        }
      };
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
      } else {
        gone.classList.add('is-leaving');
        setTimeout(finish, 180);
      }
      return;
    }

    var btn = e.target.closest('[data-feral-look-add]');
    if (!btn || btn.disabled || busy) return;
    var card = btn.closest('[data-feral-look]');
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!card || !variantId) return;

    busy = true;
    var keyboard = false;
    try { keyboard = card.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); } catch (err) {}
    var msg = card.querySelector('[data-feral-look-msg]');
    if (msg) msg.textContent = '';
    btn.classList.add('is-adding');
    btn.setAttribute('aria-busy', 'true');

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: root
      })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        // Shopify reports a failed add (sold out a moment ago) with `status`.
        if (!res.ok || res.data.status) {
          var err = new Error('add failed');
          err.detail = res.data && (res.data.description || res.data.message);
          throw err;
        }
        swap(res.data.sections);
        var body = document.querySelector('cart-drawer .feral-cart__body');
        if (body) body.scrollTop = 0;
        var landed = document.querySelector('.feral-cart__item[data-variant-id="' + variantId + '"]');
        if (landed) {
          landed.classList.add('is-arrived');
          if (keyboard) {
            var name = landed.querySelector('.feral-cart__name');
            if (name) name.focus();
          }
        }
        say((btn.getAttribute('data-label') || 'Item') + ' added to your bag.');
      })
      .catch(function (err) {
        btn.classList.remove('is-adding');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
        if (msg) msg.textContent = (err && err.detail) || 'That did not go through. Try again.';
      })
      .then(function () { busy = false; });
  });
})();
